import { GET_PLANT_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PLANT_TYPES_SUCCESS: {
      const plantTypes = action.payload;

      if (!plantTypes){
        return [...state];
      }

      return [
        ...state,
        ...plantTypes
      ]
    }
    default:
      return state;
  }
}
